import { computed } from 'mobx';

export default class ParameterModel {
  id;
  store;

  constructor(store, parameter) {
    this.store = store;
    this.id = +parameter.id;
    this.name = parameter.name;
    this.code = parameter.code;
    this.description = parameter.description;
    this.property = parameter.property;
    this.parameter_type_id = +parameter.parameter_type_id;
    this.parameter_unit_id = +parameter.parameter_unit_id;
    this.parameter_unit_name = parameter.parameter_unit_name;
    this.parameter_unit_symbol = parameter.parameter_unit_symbol;
    this.tags = parameter.tags || [];
    this.table = parameter.table;
    this.interval = parameter.interval;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      code: this.code,
      description: this.description,
      property: this.property,
      parameter_type_id: +this.parameter_type_id,
      parameter_unit_id: +this.parameter_unit_id,
      parameter_unit_name: this.parameter_unit_name,
      parameter_unit_symbol: this.parameter_unit_symbol,
      tags: this.tags || [],
      table: this.table || 0,
      interval: this.interval || 0
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.code = json.code;
    this.description = json.description;
    this.property = json.property;
    this.parameter_type_id = +json.parameter_type_id;
    this.parameter_unit_id = +json.parameter_unit_id;
    this.parameter_unit_name = json.parameter_unit_name;
    this.parameter_unit_symbol = json.parameter_unit_symbol;
    this.tags = json.tags || [];
    this.table = json.table;
    this.interval = json.interval;
  }
}



// WEBPACK FOOTER //
// ./src/models/ParameterModel.js